import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, unref as _unref, mergeProps as _mergeProps, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, isRef as _isRef, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("分配")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("取消分配")

import {   getCurrentInstance, ref, Ref, reactive, onBeforeMount } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { formatNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

let {
  'POST/sale/customers/page': fetchList,
  // 员工列表(不分页,下拉框)
  'GET/users/list': userListApi,
  // 分配销售
  'POST/sale/customers/divide': divideApi,
  // 取消分配
  'POST/sale/customers/divide/cancel': cancelDivideApi,
} = Api

let fullUserList: any = ref([])

onBeforeMount(() => {
  userListApi().then((_userList: object[]) => {
    fullUserList.value = _userList.map((_user: any) => {
      _user.label = `${_user.realName}(${_user.alias})`
      return _user
    })
  })
})

const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_modifyForm, MI_height
} = new tbMix(fetchList)

let customerRow = ref([])
const searchConfig = ref([
  {
    type: 'SELECT',
    label: '销售',
    value: [],
    upKey: 'saleId',
    options: fullUserList,
    props: { placeholder: '请选择销售', clearable: true},
    seleProps: {
      label: 'label',
      valueName: 'userId',
    }
  },
  {
    label: '客户ID',
    value: '',
    upKey: 'customerId',
  },
  {
    label: '客户',
    value: '',
    upKey: 'customer',
  },
])
// 添加
const addConfig = ref([])
const addFg = ref<boolean>(false)
const addHandle = () => {
  MI_modifyForm({}, addConfig, addFg, async(params: any) => {
    ElMessage.success('成功')
    addFg.value = false
    fetchData(MI_params)
  })
}

// 分配
const assingFg = ref<boolean>(false)
const assingConfig = ref([
  {
    type: 'SELECT',
    label: '员工',
    value: [],
    upKey: 'userIds',
    options: fullUserList,
    props: { placeholder: '请选择员工', clearable: true, multiple: true, 'collapse-tags': true },
    rule: [
      { required: true, message: '员工不能为空', trigger: 'change' },
    ],
    seleProps: {
      label: 'label',
      valueName: 'userId',
    }
  },
  {
    type: "TIME",
    label: "日期",
    value: '',
    upKey: 'divideDate',
    props: {
      'value-format': 'YYYY-MM-DD'
    }
  }
])
const assignHandle = () => {
  if(customerRow.value.length === 0){
    ElMessage.warning('请至少选择一条数据')
    return
  }
  MI_modifyForm({}, assingConfig, assingFg, async (params: any) => {
    let accountIds =  customerRow.value.map((e: any) => e.id)
    await divideApi({
      accountIds,
      ...params
    })
    ElMessage.success('分配成功')
    assingFg.value = false
    fetchData(MI_params)
  })
}
// 取消分配
const cancelAssignHandle = async () => {
  if(customerRow.value.length === 0){
    ElMessage.warning('请至少选择一条数据')
    return
  }
  let accountIds =  customerRow.value.map((e: any) => e.id)

  try {
    MI_identify.value = true
    await cancelDivideApi({
      accountIds
    })
    MI_identify.value = false
    ElMessage.success('取消成功')
    fetchData(MI_params)
  } catch (error) {
    MI_identify.value = false
  }
}

// 删除
const delHandle = (row: any) => { }


return (_ctx: any,_cache: any) => {
  const _component_FlexibleForm = _resolveComponent("FlexibleForm")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "分配客户搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_FlexibleForm, _mergeProps({ ref: "searchForm" }, {
          initSearch: true,
          title: true,
          searchConfig: searchConfig.value,
        }, {
              onSearchFn: _cache[0] || (_cache[0] = ($event: any) => (_unref(fetchData)($event, {}, 1)))
            }), null, 16)
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      class: "mt-10",
      onClick: assignHandle,
      type: "primary"
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }),
    _createVNode(_component_el_button, {
      class: "mt-10",
      onClick: cancelAssignHandle
    }, {
      default: _withCtx(() => [
        _hoisted_2
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      class: "mt-10",
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      onSelectionChange: _cache[1] || (_cache[1] = (row) => _isRef(customerRow) //@ts-ignore
 ? customerRow.value = row : customerRow = row),
      "max-height": _unref(MI_height) + 'px'
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "selection",
          width: "55"
        }),
        _createVNode(_component_el_table_column, {
          label: "客户ID",
          prop: "customerId",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户",
          prop: "customer",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "发票数量",
          prop: "invoiceQuantity",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "销售员",
          prop: "saleAlias",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "参考销售员",
          prop: "saler",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "入职日期",
          prop: "hiredTime",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "起始日期",
          prop: "date",
          "show-overflow-tooltip": ""
        })
      ]),
      _: 1
    }, 8, ["data", "max-height"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      small: "",
      background: "",
      total: _unref(MI_total),
      "page-size": _unref(size),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      class: "mb-5 mt-5",
      "page-sizes": [10, 30, 50, 100],
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "page-size", "currentPage", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: assingFg.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((assingFg).value = $event)),
      title: "分配"
    }, {
      default: _withCtx(() => [
        (assingFg.value)
          ? (_openBlock(), _createBlock(_component_FlexibleForm, _normalizeProps(_mergeProps({ key: 0 }, {
          searchConfig: assingConfig.value,
          submitText: '确定',
        })), null, 16))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})